
















































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { DateHelper } from "../core/helpers/dateHelper";

@Component({
  components: {},
})
export default class MySurveyPage extends Vue {
  surveyName: string = "";
  answeredDate: string = "";
  score: number | null = null;
  answers: any[] = [];
  errorMsg: string = "";

  async mounted() {
    let cid = 0;
    try {
      cid = JSON.parse(LocalStorage.getWithTimeout("cc")).id;
    } catch {
      console.error("not customer logged found");
    }

    await this.loadData(cid);
  }

  async loadData(customerId: number) {
    let url = `${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${this.$route.params.id}/${customerId}`;
    let data = await new CrudService().httpGet(url);
    if (data == null) {
      this.errorMsg = this.$t("Crash").toString();
      console.error("Crash getting my survey answers");
      return;
    }

    this.surveyName = data.survey || "";
    this.score = data.score === undefined ? null : data.score;
    this.answeredDate =
      data.answeredDate == null
        ? ""
        : DateHelper.toCultureString(data.answeredDate);
    this.answers = data.answers || [];
  }
}
